import SiteDetails from "../../components/SiteDetails";

const SiteDetailsPage: React.FC = () => {
  return <SiteDetails />;
};

export default SiteDetailsPage;
